export default __webpack_public_path__ + "static/media/logo.c9d9379b.png";